// extracted by mini-css-extract-plugin
module.exports = {"UsagePaper":"UsagePaper_UsagePaper__3s-pf"};